/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class AccountStatusFilters {
  /**
  * Matches if any value in this list equals `accountStatus`.
  */
  '_in'?: Array<AccountState>;
  /**
  * Matches if no value in this list equals `accountStatus`.
  */
  'notIn'?: Array<AccountState>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<AccountState>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<AccountState>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccountStatusFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

